import { Injectable, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { CCRoleId } from '@data-terminal/shared-models/cc';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class AdminAccessControlService {
    private readonly ccAuthService = inject(CCAuthService);

    canActivate(): boolean {
        return !!this.ccAuthService.getCurrentMembership()?.ccRoles?.find((role) => role === CCRoleId.adm);
    }
}
